export default __webpack_public_path__ + "static/media/thumb.1aa632df.png";